import { useMatches } from 'react-router-dom'

interface RouteHandle {
  title?: string
  showBreadcrumbs?: boolean
}

interface RouteInfo {
  title: string
  showBreadcrumbs: boolean
}

export const useRouteTitle = (): RouteInfo => {
  const matches = useMatches()

  const matchWithHandle = matches
    .slice()
    .reverse()
    .find(match => match.handle)

  const handle = matchWithHandle?.handle as RouteHandle

  return {
    title: handle?.title || '',
    showBreadcrumbs: handle?.showBreadcrumbs || false
  }
} 